import { Box, Dialog, DialogContent, DialogTitle, Grid2, IconButton, TextField } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { ReactElement, useState } from "react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import RedButton from "../../../Common/UI/components/RedButton";
import useIsAdminAndViewOnly from "../../../Common/UI/hooks/useIsAdminAndViewOnly";

export const CommentDialog = ({ handleCloseComments, handleAction }: { handleCloseComments: () => void; handleAction: (comment: string) => void }): ReactElement => {
  const [comment, setComment] = useState<string>("");
  const { isViewOnly } = useIsAdminAndViewOnly();
  return (
    <Dialog
      open
      aria-hidden={false}
      onClose={handleCloseComments}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "350px",
            height: "auto",
          },
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <DialogTitle>Add Comment</DialogTitle>
        <IconButton
          size="small"
          disableRipple
          sx={{
            "&:hover": {
              border: "1px solid var(--bs-gray-400)",
              borderRadius: "5px",
            },
          }}
          onClick={handleCloseComments}
        >
          <CloseIcon />
        </IconButton>
      </Box>
      <DialogContent>
        <Grid2 container justifyContent={"space-between"}>
          <Grid2 size={12}>
            <TextField
              multiline
              rows={4}
              variant="standard"
              className="txt-area"
              label="Comment"
              value={comment}
              onChange={(ev) => {
                setComment(ev.target.value);
              }}
              sx={{ width: "100%" }}
            />
          </Grid2>
          <Grid2 size={8}></Grid2>
          <Grid2 size={4} sx={{ textAlign: "right", marginTop: 2 }}>
            <RedButton
              onClick={() => {
                handleCloseComments();
                handleAction(comment);
              }}
              disabled={isViewOnly || comment.length === 0}
              text={"Send"}
            />
          </Grid2>
        </Grid2>
      </DialogContent>
    </Dialog>
  );
};
